import { useEffect, useRef } from "react";
import { defaultLocale } from "lib/i18n";
import { LANGUAGE_LOCALSTORAGE_KEY } from "config/localStorage";
export default function useFontFamilly () {
  // const lo = localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY)
  // console.log(lo);
  // console.log(12222);
  // console.log(defaultLocale);
  const currentLanguage = useRef(localStorage.getItem(LANGUAGE_LOCALSTORAGE_KEY) || defaultLocale);

  useEffect(() => {
    const zh = {
      "font-family-Regular": "HarmonyOS-Regular, sans-serif",
      "font-family-Black": "HarmonyOS-Black, sans-serif",
      "font-family-Medium": "HarmonyOS-Medium, sans-serif",
      "font-family-Bold": "HarmonyOS-Bold, sans-serif",
      "button-font-family": "HarmonyOS-Medium, sans-serif",
      "text-font-family": "HarmonyOS-Regular, sans-serif",
    };
    const en = {
      "font-family-Regular": "Inter-Regular, sans-serif",
      "font-family-Medium": "Inter-Medium, sans-serif",
      "font-family-Bold": "Inter-Bold, sans-serif",
      "button-font-family": "Inter-Bold, sans-serif",
      "text-font-family": "Inter-Medium, sans-serif",
    };
    const changeStyle = (obj) => {
      for (let key in obj) {
        document
          .getElementsByTagName("body")[0]
          .style.setProperty(`--${key}`, obj[key]);
      }
    };
    const themelist = {
      zh,
      en,
    };
    if (currentLanguage.current === 'en') {
      changeStyle(themelist['en']);
    } else {
      changeStyle(themelist['zh']);
    }
  }, [currentLanguage])
}
